import { SubcategoryDetailProps } from "../constants/settingsStructure";
import LegacySettingsRedirect from "../components/LegacySettingsRedirect";

const ScheduleDetail = ({ subcategory, categoryId }: SubcategoryDetailProps) => {
  return (
    <LegacySettingsRedirect
      title={subcategory.label}
      description="Configure schedule display and behavior settings."
      categoryId={categoryId}
    />
  );
};

export default ScheduleDetail;
